import React from 'react'
import '../../App.css'
import './KnightsOfColumbus.css'

export default function KnightsOfColumbus() {
    return(
        
        <h1>Coming Soon...</h1>
        

    ) 
}